<template>
  <div class="contentbox">
    <div class="logo">
        <img src="/static/img/logo.jpg" width="192" alt="" @click="$router.push('/')">
    </div>
    <div class="inqBox">  
      <div class="rightBox">
           
      </div>
      <div class="leftBox">
            <h1><span>人才数据库</span></h1>
            <div style="margin-top:88px;">
              <div class="textbox"><input type="text" v-model="cert.name" class="inname" placeholder="请输入姓名"/></div>
              <div class="textbox"><input type="text" v-model="cert.cardid" class="inid" placeholder="请输入证件号码"/></div>
              <div class="textbox"><input type="text" v-model="cert.code" class="incert" placeholder="请输入证书编号"/></div>             
            </div>
            <button @click="submitForm() ">查询信息</button>
      </div>     
    </div>
    <div class="textBox">     
      <h2>注意:</h2>
        <p>
         1、查询证书需经权属人同意。<br/>
         2、证书查询结果不得用于违背权属人意愿之用途。<br/>
         <!-- 3、咨询电话：010-53269736 -->
        </p>
    </div>
    <el-dialog title="请选择荣誉名称" width="50%" :visible.sync="qyoccupationFlag">
        <el-form >
          <el-form-item label="荣誉名称">
            <el-select v-model="selcertname" placeholder="请选择荣誉名称">
              <el-option v-for="(cet,index) in occupations" :key="index" :label="cet.certname" :value="cet.certname">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="occupationFlag = false">取 消</el-button>
          <el-button type="primary" @click="qyhandleInq()">确 定</el-button>
        </div>
      </el-dialog>
    <el-dialog title="请选择职业名称" width="50%" :visible.sync="occupationFlag">
        <el-form >
          <el-form-item label="职业名称">
            <el-select v-model="selcertname" placeholder="请选择职业名称">
              <el-option v-for="(cet,index) in occupations" :key="index" :label="cet.certname" :value="cet.certname">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="occupationFlag = false">取 消</el-button>
          <el-button type="primary" @click="handleInq()">确 定</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>

import { certificateGR} from '@/request/index';
//import { getCertTypes,getFindPage } from '@/request/get';
const rate = window.outerWidth / 1920;
export default {
  metaInfo: {
    meta: [
      {
        name: 'viewport', content:
          `width=1920, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`
      }
    ]
  },
  name: "inquery",
  components: {
  },
  data() {
    return {
      occupations: [],
      occupationFlag:false,
      qyoccupationFlag:false,
      seltype:"gr",
      cert: {
        name: "",
        code:"",
        cardid:"",
        certtypename:""
      },
      selcertname:"",
      gourl:"",
      arrCertTypes:[],
      arrRongyTypes:[],
      arrKetiTypes:[],
      isSelect:0
    }
  },
  mounted() {
    var lastTouchEnd = 0;
    document.addEventListener(
      "touchend",
      function (event) {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    handleInq() {
      if (!this.selcertname) {
        this.$message.error("请选择职业名称");
        return;
      }
      for(let i=0;i<this.occupations.length;i++)
      { 
        if(this.occupations[i].certname==this.selcertname)
        {
          this.cert = this.occupations[i];
          break;
        }
      }
      this.$router.push({
        name: "Show",
        query: {
          name: this.cert.name,
          code: this.cert.code,
          certtypename: this.cert.certtypename
        }
      })
    },
    qyhandleInq() {
      if (!this.selcertname) {
        this.$message.error("请选择荣誉名称");
        return;
      }
      for(let i=0;i<this.occupations.length;i++)
      { 
        if(this.occupations[i].certname==this.selcertname)
        {
          this.cert = this.occupations[i];
          break;
        }
      }
      this.$router.push({
        name: "Show",
        query: {
          name: this.cert.qiyename,
          code: this.cert.code,
          certtypename: this.cert.certtypename,
          type:'qy'
        }
      })
    },
    /**
     *  cname: "单位名称"或姓名,
        ccode: "信用代码"或证件号,
        bzcode: "证书编号"或标准号
    */
    async submitForm() {
      console.log("submitForm");
      if ((this.cert.name == "" && this.cert.code == "")
        || (this.cert.name == "" && this.cert.cardid == "")
        || (this.cert.code == "" && this.cert.cardid == "")) {
          this.$message.error("请输入姓名和证书编号或身份证号码");
          return;
        }
        let result =await certificateGR(this.cert.certtypename,this.cert.code,this.cert.name,this.cert.cardid);
      //console.log(result);
      result = result.data;
      if (result.data.length == 1){
          //this.cert = result.data[0];
          this.$router.push({
            name: "Show",
            query: {
              name: this.cert.name,
              code: this.cert.code,
              cardid: this.cert.cardid,
              certtypename: this.cert.certtypename,
              inqType:this.isSelect
            }
          })
      } else if (result.data.length>1)
        {
          this.occupations = result.data || [];
          this.occupationFlag = true;
        }
      }
  }
};
</script>
<style scoped >

.logo{
  width: 1920px;
    text-align: left;
    position: relative;
    margin:auto;
}
.logo img {
  margin-top: 50px;
  margin-left: 70px;
}
.contentbox{
  position: relative;
    width: 100%;
    margin: 0 auto;
height: 1080px;
    background-image:url(/static/img/jiegugobeijign.png);
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: left bottom;
    overflow: hidden;
}
.inqBox{
    position: relative;
    margin: 37px auto 41px;
    box-sizing: border-box;
  width: 1165px;
height: 668px;
background: #FFFFFF;
box-shadow: 0px 12px 51px 0px rgba(68,98,207,0.19);
opacity: 0.9;
border-radius: 5px;
}
.leftBox h1{
  position: relative;
  margin-top: 50px;
height: 35px;
font-size: 35px;
font-family: PingFang SC;
font-weight: bold;
color: #252626;
line-height: 35px;
text-align: center;
}
.leftBox h1::after{
  position: absolute;
  content:'';
  left:290px;
  bottom:-29px;
 width: 37px;
height: 8px;
background: #4462CF;
border-radius: 3px;
}
.leftBox input {
  border:0;
padding-left: 90px;
background-position: 9px 13px;
font-size: 21px;
width: 464px;
height: 67px;
background: #F2F4F9;
background-repeat: no-repeat;
border-radius: 5px;
background-position: 23px center;
}
.leftBox input::placeholder{
  color:#9BA1A8;
}
.leftBox .intype{
      margin-top:40px ;
    padding-left: 90px;
    background-position: 9px 13px;
    
    font-size: 21px;
    width: 374px;
height: 67px;
background: #F2F4F9;
background-repeat: no-repeat;
border-radius: 5px;
background-position: 23px center;
}
.textbox{
  margin: 0 auto;
  position: relative;
    margin-top:29px ;
   width: 464px;
height: 67px;
background: #F2F4F9;

}
.intype::before,.textbox::before{
    content:'';
    position: absolute;
    top:21px;
    left: 72px;
    width: 1px;
height: 25px;
background: #E3E6EF;
z-index: 1;
   }
.leftBox .inid{
    background-image: url(/static/img/suousouso.png);
}
.leftBox .incert{
    background-image: url(/static/img/suousouso.png);
}
.leftBox .inname{
  background-image: url(/static/img/geren.png);
}
.leftBox .intype{
  background-image: url(/static/img/da.png);
}
.leftBox button {
  border:0;
  margin-top: 63px;
  width: 464px;
height: 67px;
background: #4462CF;
border-radius: 5px;
font-size: 29px;
font-family: PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 67px;
text-align: center;
opacity: 1;
}
.inqBox{
  width: 1165px;
height: 668px;
background: #FFFFFF;
box-shadow: 0px 12px 51px 0px rgba(68,98,207,0.19);
opacity: 0.9;
border-radius: 5px;
  display: flex;
}
.leftBox{
  position: relative;

  width:669px;
  /* height: */
  height: 648px;
 text-align: center;
  display: inline-block;
  background: #FFFFFF;
  opacity: 1;
  z-index: 2;
}
.rightBox{
width: 583px;
height: 668px;
background-image:url(/static/img/kaoshichaxun.png);
    background-size: 583px 668px;
}
.textBox{
  position: relative;
  width: 1165px;
  margin: 0 auto;
  text-align: left;
}
.textBox h2{
height: 30px;
font-size: 14px;
font-family: PingFang SC;
font-weight: bold;
color: #FFB923;
line-height: 14px;
padding-bottom: 16px;
}
.textBox p{
height: 70px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #E8EDF8;
line-height: 28px;
}
.intype >>>.el-input__inner{
  background-color:transparent;
  border:none;
  height: 67px;
    line-height: 67px;
    padding:0px;
    font-size: 21px;
    color: #000000;
}
.btngroup{
  position: relative;
    color: #585B63;
    font-size: 20px;
    width: 400px;
    height:296px;
    padding-top: 15px;
}
.btngroup ul li {
  position: relative;
  width: 314px;
  height: 70px;
  padding-left: 32px;
  padding-right:54px;
  text-align: left;
  line-height: 70px;
  font-size: 20px;
}
.btngroup ul li::after{
  content:'';
  position: absolute;
  left:24px;
  bottom:0;
  width: 358px;
height: 1px;
border: 1px solid #FFFFFF;
opacity: 0.8;
}
.btngroup ul li a{
  color:#585B63;
}
.btngroup ul li.active{
  background-image:url(/static/img/img/youbiansnaji.png);
  background-repeat: no-repeat;
  background-size: 11px 13px;
  background-position:335px center;
}
.btngroup ul li{
  background-image:url(/static/img/img/bianlji.png);
  background-repeat: no-repeat;
  background-size: 8px 16px;
  background-position:337px center;
}
.btngroup ul li a.active{
  font-size: 20px;
  color: #4462CF;
  font-weight: bold; 
}
.kouniu1{
  position: relative;
    top: -180px;
    left: 110px;
    width: 52px;
}
.kouniu2{
  position: relative;
    top: -67px;
    left: 57px;
    width: 52px;
}
.inqBox .backhome{
  font-size: 14px;
    float: right;
    color: #fff;
    border-bottom: solid 1px;
}
.inqBox .header ul{
  display: flex;
  /* width: 500px;
  padding-left: 55px; */
  width: 1200px;
}
.inqBox .header ul li{
  
  display: inline-block;
  width: 600px;
  
}
.inqBox .header ul li a{
  font-size: 20px;
  /* border-bottom: solid 1px; */
  color: #fff;
}
.active span{
  /* color: #ffcc1a;
  border-bottom:#ffcc1a; */
}
.btntwo{
  margin-top:40px;
}
.btntwo .kouniu2{
 top: -88px
}
.btntwo .kouniu1{
  top:38px;
}
  .recodenum{
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 34px;
    height: 14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #AEB8C3;
    line-height: 14px;
    text-align: center;
  }
</style>
